'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listener = exports.setHistory = undefined;
exports.go = go;
exports.replace = replace;

var _Logger = require('./utils/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * dynamicly put value to History Object
 * mainly called by RouteHistory
 * @method set
 *
 * @param {string} key
 * @param {object} value
 * @return none
 */


var setHistory = exports.setHistory = function setHistory(history) {
  HistoryControl.history = history;
};

var listener = exports.listener = function listener(location, action) {
  HistoryControl.path = location.pathname;
  HistoryControl.state = location.state;
};

function go(pathOrIndex, state) {
  if (typeof pathOrIndex === 'number') {
    if (pathOrIndex === -1) {
      HistoryControl.history.goBack();
    } else if (pathOrIndex === 1) {
      HistoryControl.history.goForward();
    } else {
      HistoryControl.history.go(pathOrIndex);
    }
  } else {
    if (pathOrIndex === HistoryControl.path) return;

    if (HistoryControl.history) {
      HistoryControl.history.push({
        pathname: pathOrIndex,
        state: state
      });
      HistoryControl.history.goForward();
    } else {
      setTimeout(function () {
        if (HistoryControl.history) {
          HistoryControl.history.push({
            pathname: pathOrIndex,
            state: state
          });
          HistoryControl.history.goForward();
        }
      }, 0);
    }
  }
}

function replace(path, state) {
  HistoryControl.history.replace({
    pathname: path,
    state: state
  });
}
/**
 * export History Object to outer' using
 */


var HistoryControl = {
  path: '/',
  state: null,
  go: go,
  replace: replace
};
exports.default = HistoryControl;